import React from "react"
import { CATALOGS_DE } from "../../consts/catalogConsts"


export const Catalogs = () => {
    return (
        <div className="catalog" id="catalog">
            <h3 className="w-100 text-center mb-4">
                KATALOGE
            </h3>
            <div className="catalogs-pdf-container">
                {
                    CATALOGS_DE.map((catalogData, index) => (
                        <React.Fragment key={index}>

                            <a href={catalogData.file} target="_blank" rel="noreferrer" >
                                <i class="fas fa-file-pdf file-icon" />
                                {catalogData.name}
                                <i class="fas fa-download download-icon"></i>
                            </a>
                        </React.Fragment>
                    ))
                }
            </div>

        </div>
    )
}